export enum IndexTypes{
    normal,
    array
}